import {jwtDecode} from 'jwt-decode';

export function isJwtTokenExpired(jwtToken) {
    if (!jwtToken) {
        return true;
    }
    try {
        const decodedToken = jwtDecode(jwtToken);
        const dateNow = new Date();
        return decodedToken.exp * 1000 < dateNow.getTime();
    } catch (e) {
        return true;
    }
}

export function decodeJwtToken(jwtToken) {
    if (!jwtToken) {
        return;
    }
    try {
        return jwtDecode(jwtToken);
    } catch (e) {
        return;
    }
}
